<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card">
                    <div class="card-header border-0 pb-4">
                        <!-- <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div> -->
                        <img class="mx-auto d-block" src="./../assets/launching_logo.png">
                    </div>
                    <div class="card-body px-lg-5 py-lg-5">

                        <!-- <div class=" text-muted mb-4">
                            <small>Or sign in with credentials</small>
                        </div> -->
                        <form role="form">
                            <div class="alert alert-danger text-center" v-if="show == true">{{ message }}</div>
                            <div class="form-group">
                                <base-input class="input-group-alternative mb-3"
                                        placeholder="Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="model.email">
                                </base-input>
                                <div class="invalid-feedback" v-if="validation.email == false">  
                                    Email address is required.
                                </div> 
                            </div>
                            
                            <div class="form-group">
                                <base-input class="input-group-alternative"
                                        placeholder="Password"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="model.password">
                                </base-input>
                                <div class="invalid-feedback" v-if="validation.email == false">  
                                    Password is required. 
                                </div> 
                            </div>
                            

                            <!-- <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox> -->
                            <div class="text-center">
                                <base-button type="primary" class="my-4" @click="signIn()">Sign in</base-button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <!-- <a href="#" class="text-light"><small>Forgot password?</small></a> -->
                    </div>
                    <div class="col-6 text-right">
                        <!-- <router-link to="/register" class="text-light"><small>Create new account</small></router-link> -->
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  export default {
    name: 'login',
    data() {
      return {
        show: false,
        message: '',
        model: {
          email: '',
          password: ''
        },
        validation: {
            email: true,
            password: true
        }
      }
    },

    methods: {
        signIn () {
            var querystring = require('querystring');

            this.$store.dispatch('login', querystring.stringify({
                grant_type : 'password',
                username : this.model.email,
                password : this.model.password
            })).then (response => {
                localStorage.setItem('access_token', response.data.access_token);
                this.$router.push('dashboard')
            }).catch (error => {
                this.message = 'The username or password is incorrect.';
                this.show = true;
            });
        }
    }
  }
</script>
<style>
</style>
